"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomTableCell = (0, _styles.withStyles)(function (theme) {
  return {
    head: { minWidth: "100px", backgroundColor: "#fffad8", color: "#505050", padding: "7px 8px", fontSize: "11px", fontWeight: "500" },
    body: {
      minWidth: "100px",
      padding: "7px 0px 6px 2px",
      fontSize: "11px",
      fontWeight: "500",
      // maxWidth: "136px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  };
})(_core.TableCell);

var styles = function styles(theme) {
  return {
    root: { width: "100%", marginTop: theme.spacing.unit * 2 },
    table: { minWidth: 500 }
  };
};

var BasicTable = function BasicTable(props) {
  var data = props.data,
      columns = props.columns,
      keyList = props.keyList;

  return _react2.default.createElement(
    _core.Table,
    { style: { minWidth: 650, marginTop: "12px", background: "ghostwhite" }, "aria-label": "simple table" },
    _react2.default.createElement(
      _core.TableHead,
      null,
      _react2.default.createElement(
        _core.TableRow,
        null,
        columns && columns.length > 0 && columns.map(function (column) {
          return _react2.default.createElement(
            CustomTableCell,
            { style: { color: "white", background: "darkgray", fontWeight: "600" } },
            column
          );
        })
      )
    ),
    _react2.default.createElement(
      _core.TableBody,
      null,
      data && data.length > 0 && data.map(function (row, index) {
        return _react2.default.createElement(
          _core.TableRow,
          { key: index },
          keyList.map(function (key) {
            return _react2.default.createElement(
              CustomTableCell,
              { key: key, component: "th", scope: "row" },
              row[key]
            );
          })
        );
      })
    )
  );
};
exports.default = (0, _styles.withStyles)(styles)(BasicTable);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/components/MaterialTable/index.js
// module id = 2144
// module chunks = 1137